import common from './common.json';

export const ja = {
  common
};
